import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import router from '../router'
import {
  BASEURL
} from './baseUrlConfig'
import {
  MessageBox,
  Message
} from 'element-ui'
import writeSystemLog from './writeSystemLog'

let baseUrl = BASEURL

// 服务端设置基础URL
axios.defaults.baseURL = baseUrl.main
Vue.prototype.$http = axios
// 是否有请求在刷新token
window.isRefreshing = false
// 被挂起的请求数组
let subscribesArr = []
// 超时提示时间
let timeOutDate = 0
// push所有请求到数组中
function subscribeTokenRefresh(cb) {
  subscribesArr.push(cb)
}
// 用新token发起请求
function reloadSubscribesArr(token) {
  subscribesArr.map((cb) => cb(token))
}

// // 被挂起的请求数组,不同的url
// let subscribesArr1 = []
// // push所有请求到数组中
// function subscribeTokenRefresh1(cb) {
//   subscribesArr1.push(cb)
// }
// // 用新token发起请求
// function reloadSubscribesArr1(baseUrl) {
//   subscribesArr1.map(cb => cb(baseUrl))
// }
/**
 * 快过期了 和 已经过期了
 * @returns {boolean}
 */
function isTokenExpired() {
  let expiredTime = store.state.expirationTime
  if (expiredTime) {
    let nowTime = new Date().getTime()
    let willExpired = (expiredTime - nowTime) / 1000 < 10 * 60
    return willExpired
  }
  return false
}
/**
 * 是否显示请求超时
 * @returns {boolean}
 */
function isShowTimeOut() {
  if (timeOutDate !== 0) {
    let nowTime = new Date().getTime()
    let willExpired = (nowTime - timeOutDate) / 1000 > 10
    return willExpired
  }
  return false
}

// 设置是否为首次token失效
function setIsFirstTokenExpired(isReset = false) {
  if (isReset) {
    // 是否为首次token失效（若是则有警告提示）
    localStorage.setItem('isFirstTokenExpired', 0)
  } else {
    // 次数递增，当数值为1时才显示弹窗
    let expiredNumber = getIsFirstTokenExpired() + 1
    localStorage.setItem('isFirstTokenExpired', expiredNumber)
  }
}

function getIsFirstTokenExpired() {
  return Number(localStorage.getItem('isFirstTokenExpired'))
}

function directLogin() {
  let expiredNumber = getIsFirstTokenExpired()
  if (expiredNumber === 1) {
    Message({
      type: 'warning',
      message: '长时间未操作，请重新登录'
    })
  }
  // 关闭所有遮罩层
  store.dispatch('shutloader')
  router.push('/Login')
}
// http request 请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (
      config.headers.loading === undefined ||
      config.headers.loading === true
    ) {
      store.dispatch('showloader')
    }
    if (config.headers.cooperation) {
      config.baseURL = baseUrl.cooperation
    } else if (config.headers.ipSearch) {
      config.baseURL = 'https://ip.useragentinfo.com'
    } else {
      config.baseURL = baseUrl.main
    }
    // 如果是不需要token的接口直接返回即可
    if (
      config.url.startsWith('/login') ||
      config.url === '/login' ||
      config.url === '/refresh-token' ||
      config.url === '/Bugs/YKAction/add' ||
      config.headers.ipSearch
    ) {
      return config
    }
    // 获取token
    const token = store.state.accessToken
    // 如果token存在，首先校验是否已经过期，如果已经过期，跳转到登录页面
    if (token) {
      let refreshToken = store.state.refreshToken
      if (isTokenExpired() && config.url !== '/refresh-token') {
        if (!window.isRefreshing) {
          window.isRefreshing = true

          axios
            .post('/refresh-token', {
              accessToken: token,
              refreshToken: refreshToken,
            })
            .then(({
              data: res
            }) => {
              window.isRefreshing = false
              if (res.isSuccess) {
                const tokenVo = res.data
                const expiredTime =
                  new Date().getTime() +
                  store.state.effectiveMinutes * 60 * 1000

                store.commit('set_accessToken', tokenVo)
                store.commit('set_expirationTime', expiredTime)

                setIsFirstTokenExpired(true)

                reloadSubscribesArr(tokenVo)
              } else {
                setIsFirstTokenExpired(false)

                // token过期
                subscribesArr = []
                directLogin()
              }
            })
            .catch(() => {
              window.isRefreshing = false
              subscribesArr = []
              setIsFirstTokenExpired(true)
              directLogin()
            })
        }
        let retry = new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            config.headers.Authorization = `Bearer ${newToken}`
            resolve(config)
          })
        })
        return retry
      } else {
        // 正常请求
        config.headers.Authorization = `Bearer ${token}`
        return config
      }
    } else {
      setIsFirstTokenExpired(true)
      // 没有token，跳转回首页
      directLogin()
    }

    // return config
  },
  (err) => {
    return Promise.reject(err)
  }
)
// 设置全局的请求次数，请求的间隙
axios.defaults.retry = 4
axios.defaults.retryDelay = 1000
axios.interceptors.response.use(
  function (response) {
    store.dispatch('hideloader')
    if (
      response &&
      response.config &&
      response.config.headers &&
      response.config.headers.print
    ) {
      if (response.data && response.data.type === 'text/plain') {
        var reader = new FileReader()
        reader.readAsText(response.data, 'utf-8')
        reader.onload = function () {
          if (reader.result !== '') {
            try {
              const result = JSON.parse(reader.result)
              MessageBox.alert(result.errorMessage, '提示', {
                type: 'error',
                showClose: false,
                confirmButtonText: '确定',
              })
            } catch (e) {
              MessageBox.alert(reader.result, '提示', {
                type: 'error',
                showClose: false,
                confirmButtonText: '确定',
              })
            }
          }
        }
        response.data = new Blob([''], {
          type: 'text/plain',
        })
        return response
      } else {
        return response
      }
    } else {
      if (response.config.url !== '/Bugs/YKAction/add') {
        // 拦截请求接口写入系统日志
        const logForm = writeSystemLog(response)
        if (logForm) {
          axios.post('/Bugs/YKAction/add', logForm);
        }
      }
      // 删除单据后删除对应单据的传递消息
      // if (response.config.method === 'delete' && store.state.deleteSourceVal !== 0) {
      //   axios.delete('/OA/SMNotifyBoard/source', {
      //     data: {
      //       alVuePathDetail: store.state.deleteAlVuePathDetail,
      //       sourceUrl: store.state.deleteSourceUrl,
      //       sourceValue: store.state.deleteSourceVal
      //     }
      //   })
      //   store.commit('set_deleteForm', {
      //     id: 0,
      //     sourceUrl: '',
      //     alVuePathDetail: ''
      //   })
      // }
      return response
    }
  },
  function axiosRetryInterceptor(err) {
    store.dispatch('hideloader')
    if (err.message.indexOf('timeout') !== -1) {
      const config = err.config
      let loading = false
      if (
        config.headers.loading === undefined ||
        config.headers.loading === true
      ) {
        loading = true
      }
      if (timeOutDate === 0 || isShowTimeOut() || loading) {
        // showTimeOut = true
        timeOutDate = new Date().getTime()
        // MessageBox({ message: '您的请求已超时', title: '提示' })
        MessageBox.alert('您的请求已超时', '提示', {
          showClose: false,
          confirmButtonText: '确定',
          callback: () => {
            timeOutDate = 0
            // showTimeOut = false
          },
        })
      }
      // MessageBox({ message: '请求超时', type: 'error', title: '提示' })
      return Promise.reject(err)
      // Promise.reject(err)
    } else {
      var config = err.config
      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) return Promise.reject(err)

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err)
      }

      // Increase the retry count
      config.__retryCount += 1

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, config.retryDelay || 1)
      })

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        return axios(config)
      })
    }
  }
)
// 设置请求超时时间
axios.defaults.timeout = 60000
Vue.config.productionTip = false

export default axios